import * as _ from 'lodash'
import * as React from 'react'
import * as ReactDOM from 'react-dom';
import { Button } from 'reactstrap';
import { isCrossingRightSideOfViewport } from '../../util/dom';

interface IBtnPopoverProps {
  header: string | JSX.Element
  className?: string
  noContentPadding?: boolean
  useHeaderView?: boolean
  useLinkView?: boolean
  showRefreshSpinner?: boolean
  btnRef?: (ref: HTMLElement) => void
  onClosed?: () => void
  disabled?: boolean
  useMobileMode?: boolean
  showSpinner?: boolean
  getToggleFn?: (toggleFn: (show?: boolean) => void) => void
  rightAlign?: boolean
  disableAutoHiding?: boolean
  popoverContentClasses?: string
}

interface IBtnPopoverState {
  showPopover: boolean
  rightAlign: boolean
}

export class BtnPopover extends React.Component<IBtnPopoverProps, IBtnPopoverState> {
  state: IBtnPopoverState = {
    showPopover: false,
    rightAlign: false,
  }

  instanceContainer: HTMLElement | null = null
  removePopoverIn2SecTimeout: number

  componentWillMount() {
    const { rightAlign = false } = this.props

    this.setState({ rightAlign })

    if (this.props.getToggleFn) {
      this.props.getToggleFn(this.togglePopover.bind(this))
    }
  }

  componentDidMount() {
    window.addEventListener('click', this.clickListener)
    window.addEventListener('resize', this.resizeListener)
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.clickListener)
    window.removeEventListener('resize', this.resizeListener)
  }

  onMouseLeave = (ev: React.MouseEvent<HTMLElement>) => {
    const twoSecondsInMilli = 2 * 1000
    this.removePopoverIn2SecTimeout = window.setTimeout(() => this.togglePopover(false), twoSecondsInMilli)
  }

  onMouseEnter = (ev: React.MouseEvent<HTMLElement>) => {
    window.clearTimeout(this.removePopoverIn2SecTimeout);
  }

  clickListener = (ev: MouseEvent) => {
    const { showPopover } = this.state
    const { disableAutoHiding } = this.props
    const clickedElement = ev.target as HTMLElement
    let isBtnPopoverClicked = false

    if (this.instanceContainer) {
      isBtnPopoverClicked = this.instanceContainer === clickedElement || this.instanceContainer.contains(clickedElement)
    }

    if (!isBtnPopoverClicked && showPopover && !disableAutoHiding) {
      this.togglePopover(false)
    }
  }

  resizeListener = () => {
    if (!this.state.showPopover) {
      return
    }

    const popoverElem = ReactDOM.findDOMNode(this)
    const popoverContentElem = (popoverElem !== null && popoverElem instanceof Element) ? popoverElem.getElementsByClassName('btn-popover-content')[0] : ''

    if (popoverContentElem && isCrossingRightSideOfViewport(popoverContentElem)) {
      this.setState({ rightAlign: true })
    }
  }

  togglePopover(showPopover = !this.state.showPopover) {
    this.setState({ showPopover }, () => {
      const { onClosed = () => ({}) } = this.props

      if (!this.state.showPopover) {
        onClosed()
      }

      this.resizeListener()
    })
  }

  setRef(ref: HTMLElement | null) {
    this.instanceContainer = ref

    if (this.props.btnRef && ref) {
      this.props.btnRef(ref)
    }
  }

  render() {
    const popoverContainerClasses = ['btn-popover-container']
    const popoverContentClasses = ['btn-popover-content']
    const { showPopover } = this.state
    const { useMobileMode, showSpinner, disableAutoHiding } = this.props

    if (showPopover) {
      popoverContainerClasses.push('show')
    }

    if (this.props.className) {
      popoverContainerClasses.push(this.props.className)
    }

    if (this.props.noContentPadding) {
      popoverContentClasses.push('btn-popover-content-no-pad')
    }

    if (this.state.rightAlign) {
      popoverContentClasses.push('btn-popover-content-right-align')
    }

    if (this.props.popoverContentClasses) {
        popoverContentClasses.push(this.props.popoverContentClasses)
    }

    return (
      <>
        {useMobileMode ?
          <section ref={(ref) => this.setRef(ref)}>
            <h5>{this.props.header}</h5>
            {this.props.children}
          </section>
          :
          <span className={popoverContainerClasses.join(' ')} ref={(ref) => this.setRef(ref)}>
            {this.props.useHeaderView ?
              <h5 className="dashboardTitle" style={{ padding: 15 }}>
                <a href="javascript:void(0)"
                  onClick={() => this.togglePopover()}
                >
                  {this.props.header}
                </a>
              </h5>
              :
              this.props.useLinkView ?
                <a href="javascript:void(0)" onClick={() => this.togglePopover()}>
                  {this.props.header}
                </a>
                :
                <Button
                  className={`bl-btn ${this.props.children === null ? 'btn-popover-hide-after' : ''} btn-popover ${showSpinner ? 'spin-icon' : ''} `}
                  color="light"
                  disabled={this.props.disabled}
                  onClick={() => this.togglePopover()} >
                  {/* showRefreshSpinner={this.props.showRefreshSpinner} */}
                  {this.props.header}
                </Button>
            }
            {this.props.children !== null &&
              <section className={popoverContentClasses.join(' ')}
                onMouseLeave={(ev) => this.onMouseLeave(ev)}
                onMouseEnter={(ev) => this.onMouseEnter(ev)}>
                {this.props.children}
              </section>
            }
          </span>
        }
      </>
    )
  }
}
